import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { timeout, map } from 'rxjs/operators';

const mainUrl = environment.url;

@Injectable({
  providedIn: 'root'
})
export class TransmediaService {

  constructor(private http: HttpClient) { }

  getAllTransmedias(): Observable<any> {
    return this.http.get(mainUrl + 'param-transmedias')
      .pipe(
        timeout(30000),
        map((res: any) => res.data)
      )
  }

  createTransmedia(form): Observable<any> {
    return this.http.post(mainUrl + 'param-transmedia', form)
      .pipe(
        timeout(30000),
        map((res: any) => res.data)
      )
  }

  getTransmediaById(id): Observable<any> {
    return this.http.get(mainUrl + 'param-transmedia/' + id)
      .pipe(
        timeout(30000),
        map((res: any) => res.data)
      )
  }

  updateTransmedia(id, form): Observable<any> {
    return this.http.put(mainUrl + 'param-transmedia/' + id, form)
      .pipe(
        timeout(30000),
        map((res: any) => res.data)
      )
  }

  deleteTransmedia(id): Observable<any> {
    return this.http.delete(mainUrl + 'param-transmedia/' + id)
      .pipe(
        timeout(30000),
        map((res: any) => res.data)
      )
  }

  getHeader() {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': window.localStorage.getItem('token')
     });

    return headers;
  }
}